import { render, staticRenderFns } from "./CompanySelection.vue?vue&type=template&id=19a8356d&scoped=true&lang=html&"
import script from "./CompanySelection.vue?vue&type=script&lang=js&"
export * from "./CompanySelection.vue?vue&type=script&lang=js&"
import style0 from "./CompanySelection.vue?vue&type=style&index=0&id=19a8356d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8356d",
  null
  
)

export default component.exports